import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

type DeleteAgentFirmParams = {
  agentFirmId: string;
};

export async function deleteAgentFirm({ agentFirmId }: DeleteAgentFirmParams) {
  const response = await fetcher(`${API_BASE_PATH}/${agentFirmId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const data = await response.json();
    return {
      success: false,
      error: data?.message || 'Failed to delete agent firm',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
